/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { APP_CONFIG as CORE_APP_CONFIG } from '@core/config/app-config';
import { AppConfigModel } from '@models/app/app-config.model';
import { RouteCodes } from '@core/config/route-codes';
import { EditableParam } from '@core/models/quotation-calculate';

export const APP_CONFIG: AppConfigModel = {
  ...CORE_APP_CONFIG,
  generic: {
    ...CORE_APP_CONFIG.generic,
    errorDisplay: 'complete',
    errorsWithRedirect: {
      'exception.que.assi.negative.answer': RouteCodes.reservedArea,
      'exception.task.close.error': RouteCodes.position
    },
    sendLogs: true,
    adaptTimezone: true
  },
  theme: {
    logoUrl: 'assets/icons/logo_banca.svg',
    bannerUrl: 'assets/icons/logo_banca_small.svg',
    footerPrimaryText: 'lbl.go_forward',
    activeViews: [
      ['QUO_PREV_STD', true],
      ['DOCS_REQ_PREFACE', true],
      ['QUO_EDIT_PREFACE', true],
      ['SIGN_PREFACE', true],
      ['QUO_AMOUNT_INPUT_READONLY', true],
      ['STEAP_HEADER_WITH_BANNER', true],
      ['STEAP_HEADER_TITLE', true],
      ['BTN_APP_STATE', true],
      ['STATE_USER', true]
    ]
  },
  security: {
    ...CORE_APP_CONFIG.security,
    authCodeRequired: false,
    authStrategy: 'cookie',
    urlOutOfAuth: [
      ...CORE_APP_CONFIG.security.urlOutOfAuth,
      'eu-de.appid.cloud.ibm.com',
      'v1/ibm',
      'native-log'
    ],
    biometricAuthEnabled: true,
    pushNotificationActive: true
  },
  labels: {
    ...CORE_APP_CONFIG.labels,
    filter: { key: 'ct', value: 'WEBAPP' }
  },
  wizard: {
    ...CORE_APP_CONFIG.wizard,
    startPage: 'first-open-step',
    nextPage: 'first-open-step',
    closingMode: 'workflow',
    avoidBack: true,
    freeNavigation: false,
    dummyWizards: {
      ['POST_VENIDTA_SVINCOLO_TFR']: {
        wizardCode: 'PV-TFR-REL',
        status: 0,
        steps: [
          {
            stepCode: 'WEB-STAMP-CONTR-TFR',
            status: 0
          }
        ]
      },
      ['POST_VENIDTA_RECESSO']: {
        wizardCode: 'PV-WITHDRAW',
        status: 0,
        steps: []
      }
    },
    themes: {
      ['POST_VENIDTA_SVINCOLO_TFR']: 'after-sales',
      ['POST_VENIDTA_RECESSO']: 'after-sales'
    }
  },
  upload: {
    ...CORE_APP_CONFIG.upload,
    documentPages: {
      ['B03.1']: 'front|back',
      ['B03.3']: 'front|back',
      ['B04']: 'front|back'
    },
    documentPictures: [
      'B03.1',
      'B03.2',
      'B03.3',
      'B03.4',
      'CIE',
      'B05',
      'F22',
      'B04',
      'B07',
      'B94',
      'F06'
    ],
    additionalPages: {
      ['F22']: 20,
      ['B05']: 20,
      ['B07']: 20,
      ['B94']: 20,
      ['B09']: 20,
      ['B95']: 20,
      ['F06']: 20
    },
    avoidInstructions: true,
    gridOnPreview: true
  },
  form: {
    ...CORE_APP_CONFIG.form,
    stepCodeAsCode: true,
    fixedCol: true,
    searchInterface: 'modal',
    selectInterface: 'action-sheet',
    calendarInterface: 'popover'
  },
  survey: {
    ...CORE_APP_CONFIG.survey,
    alertWhenContinue: true,
    stepCodeAsCode: true,
    fixedCol: true,
    searchInterface: 'modal',
    selectInterface: 'action-sheet'
  },
  quotation: {
    primaryData: [
      {
        id: 'netDisbursedAmountToCustomer',
        title: 'lbl.quotation_upright',
        format: 'currency'
      },
      {
        id: 'installment',
        title: 'lbl.quotation_installment',
        format: 'currency'
      },
      {
        id: 'duration',
        title: 'lbl.quotation_duration',
        format: 'month'
      },
      { id: 'tan', title: 'lbl.quotation_tan', format: 'perc' },
      { id: 'taeg', title: 'lbl.quotation_taeg', format: 'perc', bold: true },
      {
        id: 'netDisbursedAmountToCustomer',
        title: 'lbl.quotation_cqs_net_disbursed',
        format: 'currency'
      },
      {
        id: 'montante',
        title: 'lbl.quotation_theoretical_total_amount',
        format: 'currency'
      },
      {
        id: 'interessi',
        title: 'lbl.quotation_interests',
        format: 'currency'
      }
    ],
    editableParams: [EditableParam.instalment],
    rejectAllowed: true,
    view: 'step-by-step',
    moduleCodes: ['comm-offer', 'pre-contr', 'pre-contr-insurance'],
    moduleCodesToMark: ['comm-offer', 'pre-contr', 'pre-contr-insurance'],
    moduleCodesToView: ['comm-offer', 'pre-contr', 'pre-contr-insurance']
  },
  quotationCalculate: {
    ...CORE_APP_CONFIG.quotationCalculate,
    preparationSections: [EditableParam.amount, EditableParam.duration],
    editableSections: [EditableParam.amount, EditableParam.duration],
    detailsInline: true
  },
  documentsRequest: {
    ...CORE_APP_CONFIG.documentsRequest,
    checkFormPrefix: 'SB_',
    identifyToValidateWithAttribute: 'VER_WEB_APP',
    ignoreMandatoryFor: true
  },
  digitalSignature: {
    positionMustBe: [
      ['==100', 'DTA-RDY'],
      ['==100', 'RIC-RAG'],
      ['>100', null]
    ],
    avoidNextAfterVerify: true
  }
};
